export const DATA = {
  actors: [
    {
      name: "Mark Ruffalo",
      rank: 1,
      value: 66.7,
    },
    {
      name: "Josh Brolin",
      rank: 2,
      value: 66.08333333333333,
    },
    {
      name: "Oscar Isaac",
      rank: 3,
      value: 64.66666666666667,
    },
    {
      name: "Chris Evans",
      rank: 4,
      value: 64.66666666666667,
    },
    {
      name: "Gwyneth Paltrow",
      rank: 5,
      value: 64.1,
    },
    {
      name: "Benedict Cumberbatch",
      rank: 6,
      value: 63.33333334,
    },
    {
      name: "Chris Hemsworth",
      rank: 7,
      value: 62.785714285714285,
    },
    {
      name: "Samuel L. Jackson",
      rank: 8,
      value: 62.333333333333336,
    },
    {
      name: "Scarlett Johansson",
      rank: 9,
      value: 62.1875,
    },
    {
      name: "Ryan Reynolds",
      rank: 10,
      value: 61.6,
    },
    {
      name: "Tom Holland",
      rank: 11,
      value: 61,
    },
    {
      name: "Robert Downey Jr.",
      rank: 12,
      value: 60.8,
    },
    {
      name: "Bill Skarsgård",
      rank: 13,
      value: 60.5,
    },
    {
      name: "Jon Favreau",
      rank: 14,
      value: 59.3,
    },
    {
      name: "Matthew McConaughey",
      rank: 15,
      value: 54.2,
    },
    {
      name: "Margot Robbie",
      rank: 16,
      value: 53.2,
    },
  ],
  directors: [
    {
      name: "Anthony Russo and Joe Russo",
      rank: 1,
      value: 87,
    },
    {
      name: "Brad Bird",
      rank: 2,
      value: 85.5,
    },
    {
      name: "Rian Johnson",
      rank: 3,
      value: 73.5,
    },
    {
      name: "J.J. Abrams",
      rank: 4,
      value: 72.75,
    },
    {
      name: "Jeremiah S Chechik",
      rank: 5,
      value: 65,
    },
    {
      name: "Sam Taylor-Johnson",
      rank: 6,
      value: 64,
    },
    {
      name: "David Leitch",
      rank: 7,
      value: 63.25,
    },
    {
      name: "Colin Trevorrow",
      rank: 8,
      value: 63,
    },
    {
      name: "Andres Muschietti",
      rank: 9,
      value: 62.25,
    },
    {
      name: "Rob Letterman",
      rank: 10,
      value: 61.25,
    },
    {
      name: "Matt Reeves",
      rank: 11,
      value: 61,
    },
    {
      name: "Jeff Fowler",
      rank: 12,
      value: 61,
    },
    {
      name: "Steven Spielberg",
      rank: 13,
      value: 60.5,
    },
    {
      name: "Shane Black",
      rank: 14,
      value: 60,
    },
    {
      name: "Roger Allers",
      rank: 15,
      value: 60,
    },
    {
      name: "Rob Minkoff",
      rank: 16,
      value: 60,
    },
    {
      name: "Joe Russo",
      rank: 17,
      value: 60,
    },
    {
      name: "Jim Gillespie",
      rank: 18,
      value: 60,
    },
    {
      name: "Anthony Russo",
      rank: 19,
      value: 60,
    },
    {
      name: "Joss Whedon",
      rank: 20,
      value: 60,
    },
  ],
  hypes: [
    {
      difference: -24,
      hypeScore: 91,
      metaCritic: 6.7,
      name: "Star Wars: The Force Awakens",
      rank: 1,
      releaseScore: 67,
    },
    {
      difference: 0,
      hypeScore: 87,
      metaCritic: 8.7,
      name: "Avengers: Infinity War",
      rank: 2,
      releaseScore: 87,
    },
    {
      difference: -8,
      hypeScore: 86,
      metaCritic: 7.8,
      name: "Incredibles 2",
      rank: 3,
      releaseScore: 78,
    },
    {
      difference: -32,
      hypeScore: 74,
      metaCritic: 4.2,
      name: "Star Wars: The Last Jedi",
      rank: 4,
      releaseScore: 42,
    },
    {
      difference: 5,
      hypeScore: 73,
      metaCritic: 7.7,
      name: "Deadpool 2",
      rank: 5,
      releaseScore: 77,
    },
    {
      difference: 5,
      hypeScore: 71,
      metaCritic: 7.5,
      name: "Pokémon Detective Pikachu",
      rank: 6,
      releaseScore: 75,
    },
    {
      difference: 9,
      hypeScore: 70,
      metaCritic: 7.8,
      name: "IT",
      rank: 7,
      releaseScore: 78,
    },
    {
      difference: 8,
      hypeScore: 64,
      metaCritic: 7.2,
      name: "TENET",
      rank: 8,
      releaseScore: 72,
    },
    {
      difference: 21,
      hypeScore: 61,
      metaCritic: 8.2,
      name: "Sonic The Hedgehog",
      rank: 9,
      releaseScore: 82,
    },
    {
      difference: 13,
      hypeScore: 61,
      metaCritic: 7.3,
      name: "Ready Player One",
      rank: 10,
      releaseScore: 73,
    },
    {
      difference: 15,
      hypeScore: 60,
      metaCritic: 7.5,
      name: "Spider-Man: Far From Home",
      rank: 11,
      releaseScore: 75,
    },
    {
      difference: 2,
      hypeScore: 59,
      metaCritic: 6.1,
      name: "Solo: A Star Wars Story",
      rank: 12,
      releaseScore: 61,
    },
    {
      difference: 10,
      hypeScore: 59,
      metaCritic: 6.8,
      name: "The Lion King",
      rank: 13,
      releaseScore: 68,
    },
    {
      difference: 19,
      hypeScore: 58,
      metaCritic: 7.6,
      name: "SHAZAM!",
      rank: 14,
      releaseScore: 76,
    },
    {
      difference: 20,
      hypeScore: 57,
      metaCritic: 7.7,
      name: "John Wick: Chapter 3",
      rank: 15,
      releaseScore: 77,
    },
    {
      difference: 14,
      hypeScore: 57,
      metaCritic: 7,
      name: "Avengers: Age of Ultron Trailer",
      rank: 16,
      releaseScore: 70,
    },
    {
      difference: 22,
      hypeScore: 56,
      metaCritic: 7.8,
      name: "Thor: Ragnarok",
      rank: 17,
      releaseScore: 78,
    },
    {
      difference: 4,
      hypeScore: 56,
      metaCritic: 6,
      name: "Suicide Squad",
      rank: 18,
      releaseScore: 60,
    },
    {
      difference: 24,
      hypeScore: 55,
      metaCritic: 7.9,
      name: "Toy Story 4",
      rank: 19,
      releaseScore: 79,
    },
    {
      difference: -9,
      hypeScore: 55,
      metaCritic: 4.6,
      name: "Star Wars Episode IX",
      rank: 20,
      releaseScore: 46,
    },
    {
      difference: -25,
      hypeScore: 55,
      metaCritic: 3,
      name: "Captain Marvel",
      rank: 21,
      releaseScore: 30,
    },
    {
      difference: 22,
      hypeScore: 55,
      metaCritic: 7.6,
      name: "Rogue One: A Star Wars Story",
      rank: 22,
      releaseScore: 76,
    },
    {
      difference: 10,
      hypeScore: 55,
      metaCritic: 6.4,
      name: "Us",
      rank: 23,
      releaseScore: 64,
    },
    {
      difference: 5,
      hypeScore: 55,
      metaCritic: 5.9,
      name: "Borat: Subsequent Moviefilm",
      rank: 24,
      releaseScore: 59,
    },
    {
      difference: 34,
      hypeScore: 54,
      metaCritic: 8.8,
      name: "Spider-Man: Into the Spiderverse",
      rank: 25,
      releaseScore: 88,
    },
    {
      difference: 30,
      hypeScore: 54,
      metaCritic: 8.4,
      name: "Logan",
      rank: 26,
      releaseScore: 84,
    },
    {
      difference: 27,
      hypeScore: 54,
      metaCritic: 8.1,
      name: "Deadpool",
      rank: 27,
      releaseScore: 81,
    },
    {
      difference: 12,
      hypeScore: 54,
      metaCritic: 6.6,
      name: "Glass",
      rank: 28,
      releaseScore: 66,
    },
    {
      difference: -18,
      hypeScore: 54,
      metaCritic: 3.6,
      name: "Wonder Woman 1984",
      rank: 29,
      releaseScore: 36,
    },
    {
      difference: 30,
      hypeScore: 54,
      metaCritic: 8.3,
      name: "Dunkirk",
      rank: 30,
      releaseScore: 83,
    },
    {
      difference: 23,
      hypeScore: 54,
      metaCritic: 7.6,
      name: "Star Wars: Rogue One",
      rank: 31,
      releaseScore: 76,
    },
    {
      difference: 24,
      hypeScore: 53,
      metaCritic: 7.7,
      name: "John Wick Chapter 3",
      rank: 32,
      releaseScore: 77,
    },
    {
      difference: 22,
      hypeScore: 53,
      metaCritic: 7.5,
      name: "Once Upon a Time in Hollywood",
      rank: 33,
      releaseScore: 75,
    },
    {
      difference: 21,
      hypeScore: 53,
      metaCritic: 7.4,
      name: "El Camino: A Breaking Bad Movie",
      rank: 34,
      releaseScore: 74,
    },
    {
      difference: 10,
      hypeScore: 53,
      metaCritic: 6.3,
      name: "Justice League",
      rank: 35,
      releaseScore: 63,
    },
    {
      difference: 10,
      hypeScore: 53,
      metaCritic: 6.3,
      name: "Black Panther",
      rank: 36,
      releaseScore: 63,
    },
    {
      difference: 24,
      hypeScore: 53,
      metaCritic: 7.6,
      name: "The Disaster Artist",
      rank: 37,
      releaseScore: 76,
    },
    {
      difference: 23,
      hypeScore: 53,
      metaCritic: 7.5,
      name: "Spider-Man: Homecoming",
      rank: 38,
      releaseScore: 75,
    },
    {
      difference: 31,
      hypeScore: 52,
      metaCritic: 8.3,
      name: "BLADE RUNNER 2049",
      rank: 39,
      releaseScore: 83,
    },
    {
      difference: -7,
      hypeScore: 52,
      metaCritic: 4.5,
      name: "THE DARK TOWER",
      rank: 40,
      releaseScore: 45,
    },
    {
      difference: 34,
      hypeScore: 52,
      metaCritic: 8.5,
      name: "WON'T YOU BE MY NEIGHBOR",
      rank: 41,
      releaseScore: 85,
    },
    {
      difference: 28,
      hypeScore: 52,
      metaCritic: 7.9,
      name: "The Devil All The Time",
      rank: 42,
      releaseScore: 79,
    },
    {
      difference: 30,
      hypeScore: 51,
      metaCritic: 8,
      name: "The Lighthouse",
      rank: 43,
      releaseScore: 80,
    },
    {
      difference: 27,
      hypeScore: 51,
      metaCritic: 7.7,
      name: "Bohemian Rhapsody",
      rank: 44,
      releaseScore: 77,
    },
  ],
  locale: {
    en: {
      actors: "ACTORS",
      actorsDescription:
        "<p>When we examine the most-hyped actors, it is mostly products of the Marvel franchise that take the top spots. With a score of 67, the winner is Mark Ruffalo – famously known for his role as Hulk in the Avengers series.</p>\n<p>The Russo Brothers take the crown as most-hyped directors, but coming in a close second is Brad Bird, most well-known for directing hit animations for Pixar such as The Incredibles and Ratatouille.</p>",
      actorsTitle: "ACTORS & DIRECTORS",
      avgHype: "Avg. Hype",
      difference: "Difference",
      directors: "DIRECTORS",
      enter: "Enter",
      footer:
        '<p>Copyright © 2021, Planet 7 <a href="https://www.planet7casino.com/online-casino-real-money.php" target="_blank">Online Casino</a>, - All Rights Reserved | Gamble Aware <a href="http://begambleaware.org/" target="_blank">begambleaware.org</a></p>',
      hypeDescription:
        "<p>Hype was calculated by analysing Reddit statistics and YouTube views, whilst Release score is based off of Metacritic. Explore the Difference score to see which movies we discovered were big hits and which ones were misses.</p>\n<p>The most hyped movie trailer is Star Wars: The Force Awakens, with a whopping 107 million views on YouTube, as well as an overwhelming response on Reddit. But we can see it was a little over-hyped, ranking not-so-high release score compared to the pre-release buzz.</p>",
      hypeScore: "HYPE SCORE",
      hypeTitle: "HYPE VS RELEASE",
      name: "Name",
      rank: "Rank",
      releaseScore: "RELEASE SCORE",
      splashDescription:
        "<p>With some movie trailers raking in over 100 million views on YouTube, there’s no doubt they have the power to break the internet.</p>\n<p>Planet 7 have calculated and compared the estimated hype of movies by analysing their Reddit and YouTube hype vs their critical release to uncover the biggest hits and misses in the last five years.</p>\n",
      title: "Title",
      twitterContent:
        "Discover the most-hyped of movies of the last five years with Hits & Misses from @planet7_casino",
    },
  },
};
